/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import EnrolmentStatus from 'linced-app/enums/enrolment-status';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class LeaversListRoute extends Route {
  // Services
  @service
  store;

  model() {
    return hash({
      // TODO: Implement back-end filters for enrolment entry/exit date to limit the results.
      people: this.store.query('person', {
        type: PersonType.LEARNER,
        status: EnrolmentStatus.FORMER,
        includeFormer: true,
        include: 'enrolments',
      }),
    });
  }
}
